'use strict';
angular.module('impactx.numberInput', [])
    .filter('numberfilter', ['$window', '$locale', function ($window, $locale) {
        return function (input) {
            if ($window.isNaN(input)) {
                return '';
            }
            var formats = $locale.NUMBER_FORMATS;
            var parts = input.toString().split(".");
            return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, formats.GROUP_SEP) + (parts[1] ? formats.DECIMAL_SEP + parts[1] : "");
        };
    }])
    .directive('appPositiveNumberInput', ['$locale', function ($locale) {
        return {
            scope: {
                zeroAllowed: '=',
                watchZeroAllowed: "@",
                noDigits: "=",
                watchNoDigits: "@",
                maxValue: '=',
                minValue: '=',
                maxDecimalDigits: "=",
                noFormatting: "="
            },
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelController) {
                var formats = $locale.NUMBER_FORMATS;
                var oldValue = 0.0;

                /* only register a watcher if the attribute is set to true. this won't be set in most of the cases
                   because the scope.zeroAllowed attribute shouldn't change dynamically.
                 */
                if (scope.watchZeroAllowed) {
                    scope.$watch(function () {
                            return scope.zeroAllowed;
                        },
                        function (newValue, oldValue) {
                            if (newValue !== oldValue) {
                                if (scope.zeroAllowed) {
                                    ngModelController.$setValidity('iszero', true);
                                }
                                else {
                                    ngModelController.$setValidity('iszero', ngModelController.$modelValue === "" || ngModelController.$modelValue != 0);
                                }
                            }
                        }
                    );
                }
                if(scope.watchNoDigits) {
                    scope.$watch(function(){
                            return scope.noDigits;
                        },
                        function(newValue, oldValue){
                            if(newValue !== oldValue){
                                if(scope.noDigits){
                                    ngModelController.$setValidity('nodigits', ngModelController.$modelValue % 1 === 0);
                                }
                                else {
                                    ngModelController.$setValidity('nodigits', true);
                                }
                            }
                        });
                }
                var regExpForNumber = /[^0-9]/g;
                ngModelController.$parsers.push(function (data) {
                    var validInput = data.toString().replace(!scope.noDigits ? /[^0-9.,]+/ : /[^0-9]+/, "");
                    if (data != validInput) {
                        ngModelController.$setViewValue(validInput);
                        ngModelController.$rollbackViewValue();
                    }
                    if ((validInput.split(formats.DECIMAL_SEP).length - 1) > 1) {
                        ngModelController.$setViewValue(oldValue);
                        ngModelController.$rollbackViewValue();
                        return oldValue;
                    }
                    var decimalSpaces = 0;
                    var dataString = data.toString();
                    /* check the maxlength */
                    var splitNumber = dataString.split(formats.DECIMAL_SEP);
                    splitNumber[0] = splitNumber[0].replace(regExpForNumber, "");
                    if (splitNumber[1])
                    {
                        var decimalNumber = splitNumber[1].replace(regExpForNumber, "");
                        decimalSpaces = decimalNumber.length;
                    }
                    if (scope.maxDecimalDigits && decimalSpaces > scope.maxDecimalDigits && oldValue != undefined)
                    {
                        ngModelController.$setViewValue(oldValue);
                        ngModelController.$rollbackViewValue();
                        return oldValue;
                    }
                    var olderInput = oldValue;
                    oldValue = validInput;
                    validInput = validInput.split(formats.GROUP_SEP).join("");
                    validInput = validInput.replace(formats.DECIMAL_SEP, ".");

                    if (scope.zeroAllowed) {
                        ngModelController.$setValidity('iszero', true);
                    }
                    else {
                        ngModelController.$setValidity('iszero', validInput === "" || validInput != 0);
                    }
                    if(scope.noDigits){
                        ngModelController.$setValidity('nodigits', validInput % 1 === 0);
                    }
                    else {
                        ngModelController.$setValidity('nodigits', true);
                    }
                    if (typeof scope.maxValue === 'number' && !isNaN(scope.maxValue)) {
                        const numValue = Number(validInput);
                        if(numValue && numValue > scope.maxValue) {
                            ngModelController.$setViewValue(olderInput);
                            ngModelController.$rollbackViewValue();
                            return olderInput;
                        }
                        ngModelController.$setValidity('max', validInput <= scope.maxValue);
                    }
                    else {
                        ngModelController.$setValidity('max', true);
                    }
                    if (typeof scope.minValue === 'number' && !isNaN(scope.minValue)) {
                        ngModelController.$setValidity('min', validInput >= scope.minValue);
                    }
                    else {
                        ngModelController.$setValidity('min', true);
                    }

                    return validInput;
                });

                ngModelController.$formatters.push(function (data) {
                    if (data !== undefined && data !== null && ((data == 0 && scope.zeroAllowed) || data != 0)) // if zero is allowed also show it
                    {
                        ngModelController.$setValidity('nodigits', !scope.noDigits || (data % 1 === 0)); // this can only validate to false if we have a preset-value?
                        if(scope.noFormatting) {
                            return data;
                        }
                        var parts = data.toString().split(".");
                        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, formats.GROUP_SEP) + (parts[1] ? formats.DECIMAL_SEP + parts[1] : "");
                    }
                    else {
                        return null;
                    }
                });
            }
        }
    }]);